/*
 * @Author: chi.yong chi.yong@jitai.ai
 * @Date: 2024-05-10 14:39:15
 * @LastEditors: chi.yong chi.yong@jitai.ai
 * @LastEditTime: 2025-01-10 14:25:52
 * @FilePath: /JTFE_home_user/src/main.ts
 * @Description: main
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import './assets/css/default.scss';

import piniaPersistedstate from 'pinia-plugin-persistedstate';
import ElementPlus from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import 'element-plus/dist/index.css';
import App from './App.vue';
import router from './router/index.ts';
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import { createSticky } from '@/utils/tableSticky.ts';
import VueLazyload from 'vue-lazyload';

const pinia = createPinia();
pinia.use(piniaPersistedstate);

const app = createApp(App);

app.use(createSticky);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
app.use(pinia);
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.use(VueLazyload, {
  preLoad: 0.6,
  error: 'images/404.png', // 图片加载失败时显示的图片
  loading: 'images/loading.png', // 加载中显示的占位图片
  attempt: 3 // 尝试加载次数
});

app.mount('#app');
